export default {
  path: '/settings',
  name: 'settings',
  redirect: { name: 'settings.dashboard' },
  component: () =>
    import(/* webpackChunkName: "settings" */ '@/views/Home/Settings'),
  children: [
    {
      path: 'dashboard',
      name: 'settings.dashboard',
      component: () =>
        import(
          /* webpackChunkName: "settings.dashboard" */ '@/views/Home/Settings/Dashboard'
        )
    },
    {
      path: 'pages/faqs',
      name: 'settings.faqs',
      component: () =>
        import(
          /* webpackChunkName: "settings.faq" */ '@/views/Home/Settings/PageManager/index.vue'
        ),
      props: {
        pageType: 'faqs',
        pageTitle: 'FAQs'
      }
    }
    // {
    //   path: 'pages/privacy-policy',
    //   name: 'settings.pages.privacy',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "settings.privacy-policy" */ '@/views/Home/Settings/PageManager/index.vue'
    //     ),
    //   props: {
    //     pageType: 'privacy-and-policy',
    //     pageTitle: 'Privacy Policy'
    //   }
    // },
    // {
    //   path: 'pages/terms-of-service',
    //   name: 'settings.pages.terms-of-service',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "settings.terms-and-conditions" */ '@/views/Home/Settings/PageManager/index.vue'
    //     ),
    //   props: {
    //     pageType: 'terms-of-service',
    //     pageTitle: 'Terms of Service'
    //   }
    // }
  ]
}
